export const iconFontAwesomeTransportationTractor = (
	<i className="fa-solid fa-tractor"></i>
);
